import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import {  Router } from "@angular/router";
import {
  AuthenticationService,
  GradeService
} from "../../_services";
import {  first, takeUntil } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { ApiRequest } from "../../_models";
import { Subject, Subscription } from "rxjs";
import { Userresponsedto } from "../../_models/user/userresponsedto";
import { ClaimantGradeEnum, CustomerActionEnum, GradeStatusEnum, LogObjectActionTemplateEnum } from "../../_models/enum/solo-enum";
import { Claims } from "../../_models/common/claims";
import { ClaimsService } from "../../_services/common/claims.service";
import { DatePipe } from "@angular/common";
import {
  IRequestGradeListForAssignEmployee,
  RequestGradeListForAssignEmployee,
  GradeMappedEmployeeList,
  IGradeMappedEmployeeList,
  AddGradePanelInputModel,
  AddGradePanelOutputModel
} from "src/app/_models/grade/grade";
import { TranslateService } from "@ngx-translate/core";
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { LoggingPanelModel } from "../../_models/common/LoggingPanelModel";
import { LoggingPanelService } from "../../_services/logging-panel/logging-panel.service";
import { AppGridComponent } from "../../shared/grid/grid-component/grid.component";
import { ColDef } from "ag-grid-community";
import { CountByStatus, GridConfig } from "../../_models/common/grid/grid-config";
import { NgOption } from "@ng-select/ng-select";
import { BaseComponent } from "../../shared/base/base-component";
import { AssignGradePanelComponent } from "../assign-grade-panel/assign-grade-panel.component";
@Component({
    selector: 'grade-assign-employee',
    templateUrl: "./grade-assign-employee.component.html",
    styleUrls: ["./grade-assign-employee.component.scss"],
    standalone: false
})
export class GradeAssignEmployeeComponent extends BaseComponent implements OnInit{
  @Output() closePanelEvent = new EventEmitter<boolean>();
  @Input() isFromExternal: boolean;
  currentUserSubscription: Subscription;
  currentUser: Userresponsedto;
  localOrganisationId: any;
  localUserId: any;
  localUserName: string;
  localLoginId: string;
  claims: Claims;
  param: any;
  videoLink = HowDoIVideoLinks.AssignGradetoClaimants;
  gradeList: any[] = [];
  assignedGradeEmployeeList: any[] = [];
  unAssignedGradeEmployeeList: any[] = [];
  totalGradeCount: number;
  totalEmployeesCount: number;
  totalUnAssignedGradeEmployeeCount: number;
  selectedGradeName: string;
  selectedGradeId: number;
  masterSelectedUnassigned: any;
  checkedListUnassigned = <any>[];
  addSelected: any;
  checkedItem: any;
  disableAssigned = false;
  disableUnassigned = false;
  checkedList = <any>[];
  approveeList = <any>[];
  masterSelected: any;
  statusText: string;
  statusValue: number;
  filterSelected: boolean;
  disableDragButton = false;
  searchText: string;
  searchAssignedEmpText: string;
  searchUnAssignedEmpText: string;
  disableGradeList = false;
  howDoIVideoLinks = HowDoIVideoLinks;
  @ViewChild(AssignGradePanelComponent) assignPanelComponenet: AssignGradePanelComponent;
  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;
  gridCostCentreList: any[] = [];
  gridColumnDefs: ColDef[];
  gridConfigItems: GridConfig;
  gridFilterStatus: number = ClaimantGradeEnum.All;
  gridFilterItems: NgOption[] = [
    { id: ClaimantGradeEnum.All, name: this.translate.instant("all") },
    { id: ClaimantGradeEnum.WithGrade, name: this.translate.instant("with_grade") },
    { id: ClaimantGradeEnum.WithoutGrade, name: this.translate.instant("without_grade") }
  ];
  selectedClaimantList: any[] = [];
  sortColumn: string = 'employeeName';
  showAssignCCPanel: boolean = false;
  panelHeading: string;
  public destroyed = new Subject<any>();
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private authenticationService: AuthenticationService,
    private gradeService: GradeService,
    public datepipe: DatePipe,
    private claimsService: ClaimsService,
    private translate: TranslateService,
    private loggingPanelService: LoggingPanelService
  ) {
    super();
    this.claimsService.currentClaims.subscribe(claims => {
      this.claims = claims;
      this.localUserId = this.claims.UserId;
      this.localLoginId = this.claims.LoginId;
      this.localOrganisationId = this.claims.OrgId;
      this.localUserName = this.claims.FinanceManager;
    });
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(
      user => {
        this.currentUser = user;
      }
    );
  }

  ngOnInit(): void {
    this.statusText = GradeStatusEnum[GradeStatusEnum.Active];
    this.statusValue = GradeStatusEnum.Active;

    if (localStorage.getItem("gradeIdFromMileageRate")) {
      this.selectedGradeId = Number(localStorage.getItem("gradeIdFromMileageRate"));
      localStorage.removeItem("gradeIdFromMileageRate");
    }
    this.getGradeListForAssignEmployee();
    this.masterSelectedUnassigned = false;
    this.addSelected = true;
    this.checkedItem = false;
    this.masterSelected = false;
    this.filterSelected = false;
    this.fnInitialiseGradeGrid();
    // this.router.events.pipe(
    //   takeUntil(this.destroyed)
    // ).subscribe(() => {
    //   this.getGradeListForAssignEmployee();
    // });
  }

  fnShowConfigureshowLoggingAlertPanel(FilterID: string = "0") {
    const model = new LoggingPanelModel(
      this.claims.OrgId.toString(),
      LogObjectActionTemplateEnum.AssignGradetoClaimants.toString(),
      FilterID
    );
    this.loggingPanelService.onShowLogPanel(model);
  }

  goToGrade() {
    this.router.navigate(["orgsetting/grade"]);
  }

  fnInitialiseGradeGrid() {
    this.fnCreateColumnDefs();
    this.fnGetGridConfigItems();
    setTimeout(() => {
      this.gridComponent.initializeGrid();
    }, 100);
  }

  canDeactivate(): boolean {
    return !this.assignPanelComponenet || !this.assignPanelComponenet.hasFormChanges;
  }

  ngOnDestroy() {
    this.currentUserSubscription.unsubscribe();
  }

  fnGetGridConfigItems() {

    let totalGradeCount = this.gradeList.length;
    let activeGradeCount = this.gradeList.filter(item => Number(item.gradeId) > 0).length;
    let inactiveGradeCount = this.gradeList.filter(item => Number(item.gradeId) == 0).length;

    let countByStatusArray = [];

    countByStatusArray.push(new CountByStatus("d-block", this.translate.instant('total_claimants'), totalGradeCount, false, 0));
    countByStatusArray.push(new CountByStatus("d-inline-block inactive-state cursor-pointer padding-right-10 text-underline lH-12", this.translate.instant('all'), totalGradeCount, true, 0));
    countByStatusArray.push(new CountByStatus("d-inline-block active-state cursor-pointer padding-right-10 padding-left-10 text-underline lH-12 border-left-2px", this.translate.instant('with_grade'), activeGradeCount, true, ClaimantGradeEnum.WithGrade));
    countByStatusArray.push(new CountByStatus("d-inline-block color-red cursor-pointer text-underline lH-12 padding-left-10 border-left-2px", this.translate.instant('without_grade'), inactiveGradeCount, true, ClaimantGradeEnum.WithoutGrade));
    this.gridConfigItems = new GridConfig(
      false,
      false,
      this.sortColumn,
      "employeeId",
      this.gridFilterStatus,
      true,
      countByStatusArray,
      true,
      true,
      true,
      null,
      'desc',
      40,
      'no_data_availabe',
      null,
      null,
      false, false,
      '',
      '',
      false
    );
  }

  fnCreateColumnDefs() {
    this.gridColumnDefs = [
      {
        headerName: this.translate.instant('claimant_name'),
        field: 'employeeName',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,

      },
      {
        headerName: this.translate.instant('claimant_email'),
        field: 'employeeEmail',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,

      },
      {
        headerName: this.translate.instant('policy_grade_name'),
        field: 'gradeName',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,

      },
      {
        headerName: this.translate.instant('label_status'),
        field: 'gradeStatus',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        cellRenderer: 'fieldValueRenderer',
        minWidth: 100,
        headerComponentParams: [
          { class: 'active-color font-weight-bold', value: GradeStatusEnum.Active, text: this.translate.instant("label_active") }
        ]

      },
      {
        headerName: this.translate.instant('label_log_history'),
        field: 'log',
        cellRenderer: 'actionRenderer',
        resizable: true,
        suppressHeaderMenuButton: true,
        minWidth: 50,
        headerClass: 'text-center',
        cellClass: 'text-center',
        sortable: false,
        headerComponentParams:
          [
            {
              buttonClass: 'fas fa-file-search',
              buttonTooltip: this.translate.instant('label_log'),
              buttonAlignmentClass: 'text-center position-relative'
            }
          ]
      },
      {
        headerName: "",
        cellRenderer: 'actionRenderer',
        field: 'userActionField',
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        sortable: false,
        minWidth: 100,
        headerComponentParams:
          [
            {
              buttonClass: 'fas fa-edit color-green',
              buttonTooltip: this.translate.instant('label_edit'),
              userAction: CustomerActionEnum.Edit
            }

          ]
      }
    ];
  }

  fnOnGridCellClick(params) {
    switch (params.column.colId) {
      case 'selected':
        if (params.data.selected) {
          this.selectedClaimantList.push(params.data);
        }
        else if (!params.data.selected) {
          this.selectedClaimantList = this.selectedClaimantList.filter(e => e.employeeId != params.data.employeeId);
        }
        this.showAssignCCPanel = true;
        this.panelHeading = this.selectedClaimantList.length == 1 ? this.translate.instant('assign_grade_selected_claimant') :
          this.translate.instant('label_bulk_action') + ' (' + this.translate.instant('label_selected') + ': ' + this.selectedClaimantList.length + ')'

        break;
      case 'userActionField':
        if (!this.selectedClaimantList.find(e => e.employeeId != params.data.employeeId)) {
          this.selectedClaimantList = [params.data];
          this.gridComponent.checkItems([params.data.employeeId]);
          this.showAssignCCPanel = true;
          this.panelHeading = this.translate.instant('assign_grade_selected_claimant');
        }
        break;
      case 'log':
        this.fnShowConfigureshowLoggingAlertPanel(params.data.employeeId.toString());
        break;
    }
    this.selectedClaimantList = this.selectedClaimantList.slice();
  }

  closeAssignPanel(isSaved) {
    this.selectedClaimantList = [];
    this.gridComponent.uncheckAll();
    if (isSaved) {
      this.getGradeListForAssignEmployee();
    }
  }

  uncheckEvent(data) {
    this.selectedClaimantList = this.selectedClaimantList.filter(e => e.employeeId != data.employeeId);
    this.gridComponent.uncheckItems([data.employeeId]);
  }

  fnOnGridCheckAll(isChecked) {
    //  
    this.getCheckedItemList();
  }

  fnGridFilterChanged(filterStatus: number) {
    this.gridFilterStatus = filterStatus;
    if (filterStatus == ClaimantGradeEnum.WithGrade)
      this.gridCostCentreList = this.gradeList.filter(item => Number(item.gradeId) > 0);
    else if (filterStatus == ClaimantGradeEnum.WithoutGrade)
      this.gridCostCentreList = this.gradeList.filter(item => Number(item.gradeId) == 0);
    else
      this.gridCostCentreList = this.gradeList;
    this.fnGetGridConfigItems();
    setTimeout(() => {
      this.gridComponent.refreshGridData();
    }, 100);
  }

  getGradeListForAssignEmployee() {
    let gradeRequest = new ApiRequest<IRequestGradeListForAssignEmployee>(
      "SoloGetGradeListForAssignEmployee",
      1.0,
      "111"
    );
    let gradeRequestInfo = new RequestGradeListForAssignEmployee(
      this.localOrganisationId,
      this.statusValue
    );

    gradeRequest.requestInfo = gradeRequestInfo;

    this.gradeService
      .GetGradeListForAssignEmployee(gradeRequest)
      .pipe(first())
      .subscribe(
        (response: any) => {
          if (response.responseInfo != null) {
            this.gradeList = response.responseInfo.lstEmployee;
            this.fnGridFilterChanged(this.gridFilterStatus);
          }
        }
      );
  }

  getAssignedGradeEmployeeList(item: any) {
    this.selectedGradeName = "to " + item.gradeName;
    this.selectedGradeId = item.gradeId;
    this.assignedGradeEmployeeList = item.assignedGradeEmployeeLists;
    if (this.assignedGradeEmployeeList.length == 0) {
      this.addSelected = false;
    }
    this.masterSelected = false;
    this.checkUncheckAll();
  }

  assignGradeToEmployee() {
    let gradeRequest = new ApiRequest<IGradeMappedEmployeeList>(
      "SoloAssignDeassignGradeToEmployee",
      1.0,
      "111"
    );

    var employeesIds: number[] = [];

    this.checkedListUnassigned.forEach(item => {
      employeesIds.push(item.employeeId);
    });

    let gradeMappedEmployeeListModel = new GradeMappedEmployeeList(
      this.selectedGradeId,
      this.localOrganisationId,
      employeesIds
    );

    gradeRequest.requestInfo = gradeMappedEmployeeListModel;

    this.gradeService
      .AssignDeassignGradeToEmployeeBackground(gradeRequest)
      .pipe(first())
      .subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.toastr.info(this.translate.instant("JobSubmittedToaster"));
          this.masterSelected = false;
          this.masterSelectedUnassigned = false;
          this.searchUnAssignedEmpText = this.searchAssignedEmpText = "";
          this.getGradeListForAssignEmployee();
        }
      });
  }

  removeGradeFromEmployee() {
    let gradeRequest = new ApiRequest<IGradeMappedEmployeeList>(
      "SoloAssignDeassignGradeToEmployee",
      1.0,
      "111"
    );

    var employeesIds: number[] = [];

    this.checkedList.forEach(item => {
      employeesIds.push(item.employeeId);
    });

    let gradeMappedEmployeeListModel = new GradeMappedEmployeeList(
      null,
      this.localOrganisationId,
      employeesIds
    );
    gradeRequest.requestInfo = gradeMappedEmployeeListModel;

    this.gradeService
      .AssignDeassignGradeToEmployeeBackground(gradeRequest)
      .pipe(first())
      .subscribe((response: any) => {
if (response.statusCode == 200) {
          this.toastr.info(this.translate.instant("JobSubmittedToaster"));
          this.masterSelected = false;
          this.masterSelectedUnassigned = false;
          this.searchUnAssignedEmpText = this.searchAssignedEmpText = "";
          this.getGradeListForAssignEmployee();
        }
      });
  }

  isAllSelectedUnassigned() {
    this.masterSelectedUnassigned = this.unAssignedGradeEmployeeList.every(
      function (item: any) {
        return item.CheckBoxCheck == true;
      }
    );
    this.getCheckedItemListUnassigned();
  }

  checkUncheckAllUnassigned() {
    for (var i = 0; i < this.unAssignedGradeEmployeeList.length; i++) {
      if (this.searchUnAssignedEmpText) {
        if (this.unAssignedGradeEmployeeList[i].employeeName.toUpperCase().includes(this.searchUnAssignedEmpText.toUpperCase())) {
          this.unAssignedGradeEmployeeList[i].CheckBoxCheck = this.masterSelectedUnassigned;
        }
      } else {
        this.unAssignedGradeEmployeeList[i].CheckBoxCheck = this.masterSelectedUnassigned;
      }
    }
    this.getCheckedItemListUnassigned();
  }

  getCheckedItemListUnassigned() {
    
    this.checkedListUnassigned = [];
    for (var i = 0; i < this.unAssignedGradeEmployeeList.length; i++) {
      if (this.unAssignedGradeEmployeeList[i].CheckBoxCheck) {
        this.checkedListUnassigned.push(this.unAssignedGradeEmployeeList[i]);
        this.addSelected = false;
        this.checkedItem = true;
      }
    }
if (this.checkedListUnassigned.length > 0) {
      this.checkedItem = true;
      this.disableDragButton = false;
      this.disableAssigned = true;
      this.disableUnassigned = false;
    } else {
      this.checkedItem = false;
      this.disableDragButton = true;
      this.disableAssigned = false;
      this.disableUnassigned = false;
    }
  }

  checkUncheckAll() {
    for (var i = 0; i < this.assignedGradeEmployeeList.length; i++) {
      if (this.searchAssignedEmpText) {
        if (this.assignedGradeEmployeeList[i].employeeName.toUpperCase().includes(this.searchAssignedEmpText.toUpperCase())) {
          this.assignedGradeEmployeeList[i].CheckBoxCheck = this.masterSelected;
        }
      } else {
        this.assignedGradeEmployeeList[i].CheckBoxCheck = this.masterSelected;
      }

    }
    this.getCheckedItemList();
  }

  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.gradeList.length; i++) {
      if (this.gradeList[i].selected) {
        this.checkedList.push(this.gradeList[i]);
      }
    }

    if (this.checkedList.length > 0) {
      this.showAssignCCPanel = true;
      this.panelHeading = this.checkedList.length == 1 ? this.translate.instant('assign_grade_selected_claimant') :
        this.translate.instant('label_bulk_action') + ' (' + this.translate.instant('label_selected') + ': ' + this.checkedList.length + ')'
      this.selectedClaimantList = this.checkedList;
    } else {
      this.showAssignCCPanel = false;
    }
  }

  isAllSelected() {
    
    this.masterSelected = this.assignedGradeEmployeeList.every(function (
      item: any
    ) {
      return item.CheckBoxCheck == true;
    });
    this.getCheckedItemList();
  }

  statusChange(selectedStatus: string, statusValue: number) {
    
    this.statusText = selectedStatus;
    this.statusValue = statusValue;
    this.filterSelected = false;
    this.getGradeListForAssignEmployee();
  }

  goToSetting() {
    if (localStorage.getItem("isRedirectFromMySubscriptionSettingPage") == "1") {
      this.router.navigate(["mysubscription"]);
    } else {
      this.router.navigate(["settings"]);
    }
  }

  fnUnassignedLiOnClick(claimantId: number) {
    
    var selectedUnAssignedClaimant = this.unAssignedGradeEmployeeList.find(d => d.employeeId == claimantId);
    selectedUnAssignedClaimant.CheckBoxCheck = !selectedUnAssignedClaimant.CheckBoxCheck;

    this.isAllSelectedUnassigned();
  }

  fnAssignedLiOnClick(claimantId: number) {
    
    var selectedAssignedClaimant = this.assignedGradeEmployeeList.find(d => d.employeeId == claimantId);
    selectedAssignedClaimant.CheckBoxCheck = !selectedAssignedClaimant.CheckBoxCheck;

    this.isAllSelected();
  }
  showAddGradePanel: boolean = false;
  addGradePanelInputModel: AddGradePanelInputModel;
  fnShowAddGradePanel(gradeId: number, isEdit: boolean = false,isCopy:boolean= false) {
    this.addGradePanelInputModel = new AddGradePanelInputModel(gradeId, isEdit,isCopy);
    this.showAddGradePanel = true;
  }

fnCloseAddGradePanel(isClose: boolean) {
    if (isClose) {
        this.addGradePanelInputModel = null;
        this.gridComponent.uncheckAll();
        this.showAddGradePanel = false;
    }
}

fnSubmitAddGradePanel(response: AddGradePanelOutputModel) {
    if (response) {
        this.addGradePanelInputModel = null;  
        this.showAddGradePanel = false;
        this.getGradeListForAssignEmployee();
    }
}

fnClosePanel()
{
  this.closePanelEvent.emit(true);
}
}
